import { createSelector } from 'reselect';

import {
    projectsAndGroupsLoadingSelector,
    selectedProjectsAndGroupsLoadingSelector,
    allProjectsSelector,
    activeProjectsSelector,
    allGroupsSelector,
    activeGroupsSelector
} from './base';

export const projectsScopeLoadingSelector = createSelector([
    projectsAndGroupsLoadingSelector,
    selectedProjectsAndGroupsLoadingSelector
], (all, selected) => all || selected);

const toProjectsScopeItemList = (all, selected) => all.map(item => ({
    ...item,
    isSelected: selected.indexOf(item.id) > -1,
    color: `rgb(${item.color.r}, ${item.color.g}, ${item.color.b})`
}));

export const projectsScopeProjectsSelector = createSelector([allProjectsSelector, activeProjectsSelector], toProjectsScopeItemList);

export const projectsScopeGroupsSelector = createSelector([allGroupsSelector, activeGroupsSelector], toProjectsScopeItemList);

export const projectsScopeSelectedNamesSelector = createSelector([
    projectsScopeProjectsSelector,
    projectsScopeGroupsSelector
], (projects, groups) => (projects || groups) ? [...projects, ...groups].filter(item => item.isSelected).map(item => item.name).join(', ') : '');

export const isEmptySelector = createSelector([
    allProjectsSelector,
    allGroupsSelector
], (projects, groups) => (!projects || projects.length === 0) && (!groups || groups.length === 0));


// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/selectors/projects-scope.js